import Model from './Model'

export default class Mission extends Model {
  id: number
  email: string
  title: string
  description: string
  startDate: string
  dueDate: string
  address: string
  state: string
  reportState: string
  receiver: string
  report = null

  parseReceiver(mission) {
    this.receiver = mission.received_infos && mission.received_infos.first_name && mission.received_infos.last_name ?
    `${mission.received_infos.first_name} ${mission.received_infos.last_name}` : mission.email
  }
}
